//Creates new poster and assigns ID and type
export const createPoster = (data) => {
    //data = {id, type}
    return { type: "CREATE_POSTER", payload: data}
}
